// extracted by mini-css-extract-plugin
export var WhyInvoZone = "whyIZ-module--WhyInvoZone--fS54K";
export var invobox = "whyIZ-module--invobox--1NBNH";
export var invoitem = "whyIZ-module--invoitem--4vSqm";
export var parentInvobox = "whyIZ-module--parentInvobox--rEhgB";
export var section = "whyIZ-module--section--WTjRo";
export var text = "whyIZ-module--text--q2Hm8";